import axios from "axios";

import { config } from "config";

const Axios = axios.create({
  baseURL: config.API_URL,
  withCredentials: true
});

export default Axios;